export default async function refreshAll(done: () => void) {
  const userStore = useAuthStore()
  refreshNuxtData().then(() => {
    done()
    if (userStore.user) {
      userStore.loadUser(true)
    }
  }).finally(() => {
    done()
  })
}
